import { render, staticRenderFns } from "./BalanceHistories.vue?vue&type=template&id=1af6cc68"
import script from "./BalanceHistories.vue?vue&type=script&lang=js"
export * from "./BalanceHistories.vue?vue&type=script&lang=js"
import style0 from "./BalanceHistories.vue?vue&type=style&index=0&id=1af6cc68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports